/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { ChannelInventoryConfiguration, StoreOperationsDataActions } from '@msdyn365-commerce/retail-proxy';

/**
 * Input class for getChannelInventoryConfiguration data action.
 */
export class GetChannelInventoryConfigurationInput implements IActionInput {
    public getCacheKey = (): string => 'GetChannelInventoryConfiguration';

    public getCacheObjectType = (): string => 'ChannelInventoryConfiguration';

    public dataCacheType = (): CacheType => 'application';

    public shouldCacheOutput = () => true;
}

/**
 * Create input method which creates an ActionInput for fetching inventory configuration.
 * @param args
 */
export const createInput = (args: ICreateActionContext): IActionInput => {
    return new GetChannelInventoryConfigurationInput();
};

/**
 * Calls the Retail API and returns inventory configuration information.
 * @param input
 * @param context
 */
export async function getChannelInventoryConfiguration(
    input: GetChannelInventoryConfigurationInput,
    context: IActionContext
): Promise<ChannelInventoryConfiguration> {
    return StoreOperationsDataActions.getInventoryConfigurationAsync({
        callerContext: context
    });
}

export const getChannelInventoryConfigurationDataAction = createObservableDataAction({
    id: 'get-channel-inventory-configuration',
    action: getChannelInventoryConfiguration as IAction<ChannelInventoryConfiguration>,
    input: createInput
});

export default getChannelInventoryConfigurationDataAction;
